import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import "./Auth.css";
import { toast } from "react-toastify";

function SignupVerify() {
  const location = useLocation();
  const navigate = useNavigate();

  // Hooks
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const email = location.state?.email;

  if (!email) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2>Invalid Access</h2>
          <p className="auth-subtitle">
            Please start the signup process again.
          </p>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axiosInstance.post("/accounts/signup/verify/", {
        email,
        otp,
        password,
      });

      toast.success("Account created successfully");
      navigate("/login");
    } catch {
      toast.error("Invalid or expired OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Verify OTP</h2>
        <p className="auth-subtitle">
          Enter OTP and set your password
        </p>

        <form onSubmit={handleSubmit}>
          {/* OTP */}
          <div className="input-group">
            <input
              required
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <label>OTP</label>
            <span className="input-line"></span>
          </div>

          {/* Password */}
          <div className="input-group">
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <label>Password</label>
            <span className="input-line"></span>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Verifying..." : "Verify & Create Account"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default SignupVerify;
